import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import allAPI from "../../api/api";

const initialState = {};

export const getCategories = createAsyncThunk(
  "categoriesData",
  async (payload) => {
    try {
      const response = await allAPI.categories.getCategories(payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

// export const getSubCategory = createAsyncThunk(
//   "getSubCategoriesData",
//   async (payload) => {
//     try {
//       const response = await allAPI.categories.getSubCategory(payload);
//       if (response.status === 200) {
//         return response.data;
//       } else {
//         throw new Error(`Unexpected status code: ${response.status}`);
//       }
//     } catch (error) {
//       console.error("API call failed:", error);
//       throw error;
//     }
//   }
// );


export const createCategory = createAsyncThunk(
  "categoriesData",
  async (payload) => {
    try {
      const response = await allAPI.categories.createCategory(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);
export const updateCategory = createAsyncThunk(
  "categoriesData",
  async (payload) => {
    try {
      const response = await allAPI.categories.updateCategory(payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const createCategoryMapping = createAsyncThunk(
  "categoriesData",
  async (payload) => {
    try {
      const response = await allAPI.categories.createCategoryMapping(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const deleteCatergoryMapping = createAsyncThunk(
  "categoriesData",
  async (payload) => {
    try {
      const response = await allAPI.categories.deleteCatergoryMapping(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);
export const createSubCategoryMapping = createAsyncThunk(
  "categoriesData",
  async (payload) => {
    try {
      const response = await allAPI.categories.createSubCategoryMapping(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  },
);
export const updateCategoryType = createAsyncThunk(
  "categoriesData",
  async (payload) => {
    try {
      const response = await allAPI.categories.updateCategoryType(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  },
);


export const getSubCategory = createAsyncThunk(
  "categoriesData",
  async (payload) => {
    try {
      const response = await allAPI.categories.getSubCategory(payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const createSubCategory = createAsyncThunk(
  "categoriesData",
  async (payload) => {
    try {
      const response = await allAPI.categories.createSubCategory(payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }

  
);

const categoriesSlice = createSlice({
  name: "categoriesData",
  initialState,
  reducers: {
    set: (state, action) => {
      console.log(action, "action");
    },
  },
  extraReducers: (builder) => {
    // builder
    //   .addCase(getAllCustomers.pending, (state) => {
    //     console.log("pending");
    //   })
    //   .addCase(getAllCustomers.fulfilled, (state, action) => {
    //     console.log(action.payload, "response");
    //   })
    //   .addCase(getAllCustomers.rejected, (state, action) => {
    //     console.log("rejected");
    //   });
  },
});

export const {} = categoriesSlice.actions;

export default categoriesSlice.reducer;
